import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login, formatApiErrorDetail } from "@/lib/adminApi";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email.trim(), password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-root" data-testid="admin-login">
      <div className="auth-card">
        <p className="mono-caps auth-over">Warren Wulkan · Admin</p>
        <h1 className="auth-title">Sign in</h1>
        <form className="auth-form" onSubmit={submit}>
          <label className="auth-field">
            <span className="mono-caps">Email</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              data-testid="login-email"
            />
          </label>
          <label className="auth-field">
            <span className="mono-caps">Password</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="login-password"
            />
          </label>
          {error && <p className="auth-error" data-testid="login-error">{error}</p>}
          <button
            type="submit"
            className="auth-submit mono-caps"
            disabled={busy}
            data-testid="login-submit"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
